<template>
  <div class="content users-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover invites-card">
            <template slot="header">
              <div class="row align-items-center">
                <div class="col-md-8">
                  <h4 class="card-title mb-1">Societes invitees</h4>
                  <p class="card-category mb-1" v-if="invites.length === 0">Aucune invitation</p>
                  <p class="card-category mb-1" v-else>Liste des {{ invites.length }} invitations</p>
                  <small class="text-muted">{{ invitesSummary }}</small>
                </div>
                <div class="col-md-4 text-md-right mt-3 mt-md-0">
                  <b-button size="sm" variant="outline-secondary" @click="refreshData" :disabled="!isManager()">
                    <b-icon icon="arrow-clockwise" class="mr-1"></b-icon>
                    Actualiser
                  </b-button>
                </div>
              </div>
            </template>

            <div class="invites-table-wrapper d-flex flex-column flex-grow-1">
              <div v-if="isLoading" class="py-5 text-center text-muted flex-grow-1 d-flex flex-column justify-content-center">
                <b-spinner label="Chargement"></b-spinner>
                <p class="mt-2 mb-0">Chargement des invitations...</p>
              </div>
              <div v-else-if="!isManager()" class="empty-state text-center p-4">
                <b-icon icon="shield-lock" shift-v="-2" font-scale="2"></b-icon>
                <h5 class="mt-3">Cette section est reservee aux comptes Gestionnaires, Administrateurs ou Partenaires.</h5>
                <p class="text-muted mb-0">Contactez votre administrateur si vous devez y acceder.</p>
              </div>
              <div v-else class="d-flex flex-column flex-grow-1">
                <nav class="navbar navbar-expand-lg">
                  <li class="nav-item nav-link">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-2"
                    ></b-pagination>
                  </li>
                  <li class="nav-item nav-link d-flex align-items-center">
                    <span class="nowrap">Elements par page :</span>
                    <select v-model="perPage" class="form-control">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                    </select>
                  </li>
                  <li class="na-item nav-link">
                    <span>{{ totalRows }} / {{ invites.length }}</span>
                  </li>
                </nav>

                <b-table
                  v-if="invites.length > 0"
                  responsive
                  striped
                  hover
                  small
                  :items="filteredInvites"
                  :fields="columns"
                  :current-page="currentPage"
                  :per-page="perPage"
                  head-variant="light"
                >
                  <template #thead-top>
                    <tr>
                      <th></th>
                      <th>
                        <b-form-select
                          size="sm"
                          :options="inviteStatusOptions"
                          v-model="inviteColumnFilters.status"
                        ></b-form-select>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="inviteColumnFilters.email"
                          placeholder="Filtrer"
                        ></b-form-input>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="inviteColumnFilters.companyName"
                          placeholder="Filtrer"
                        ></b-form-input>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="inviteColumnFilters.operationCode"
                          placeholder="Filtrer"
                        ></b-form-input>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="inviteColumnFilters.operationName"
                          placeholder="Filtrer"
                        ></b-form-input>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          v-model="inviteColumnFilters.operationEntity"
                          placeholder="Filtrer"
                        ></b-form-input>
                      </th>
                      <th>
                        <div class="d-flex flex-column flex-md-row">
                          <b-form-input
                            size="sm"
                            type="date"
                            v-model="inviteColumnFilters.createdStart"
                            class="mb-1 mb-md-0"
                            placeholder="Du"
                          ></b-form-input>
                          <b-form-input
                            v-if="inviteColumnFilters.createdStart"
                            size="sm"
                            type="date"
                            v-model="inviteColumnFilters.createdEnd"
                            class="ml-md-1"
                            placeholder="Au"
                          ></b-form-input>
                        </div>
                      </th>
                      <th>
                        <div class="d-flex flex-column flex-md-row">
                          <b-form-input
                            size="sm"
                            type="date"
                            v-model="inviteColumnFilters.modifiedStart"
                            class="mb-1 mb-md-0"
                            placeholder="Du"
                          ></b-form-input>
                          <b-form-input
                            v-if="inviteColumnFilters.modifiedStart"
                            size="sm"
                            type="date"
                            v-model="inviteColumnFilters.modifiedEnd"
                            class="ml-md-1"
                            placeholder="Au"
                          ></b-form-input>
                        </div>
                      </th>
                      <th>
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          v-model="inviteColumnFilters.inviteCount"
                          placeholder="Filtrer"
                        ></b-form-input>
                      </th>
                      <th>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="resetInviteFilters"
                        >
                          Reinitialiser
                        </b-button>
                      </th>
                    </tr>
                  </template>
                  <template #cell(rank)="row">
                    {{ row.index + 1 }}
                  </template>
                  <template #cell(inviteStatus)="row">
                    {{ getInviteStatusLabel(row.item.inviteStatus) }}
                  </template>
                  <template #cell(_created)="row">
                    {{ toDate(row.item._created) }}
                  </template>
                  <template #cell(_modified)="row">
                    {{ toDate(row.item._modified) }}
                  </template>
                  <template #cell(operationCode)="row">
                    <router-link
                      v-if="row.item.operationId"
                      :to="urlWithRedirect('/ppe_eu/operation_home/' + row.item.operationId + '?tab=invites')"
                    >
                      {{ row.item.operationCode }}
                    </router-link>
                    <span v-else>{{ row.item.operationCode }}</span>
                  </template>
                  <template #cell(action)="row">
                    <router-link
                      v-if="row.item.operationId"
                      :to="urlWithRedirect('/ppe_eu/operation_home/' + row.item.operationId + '?tab=invites')"
                    >
                      Ouvrir
                    </router-link>
                  </template>
                </b-table>

                <div v-else class="empty-state text-center p-4 flex-grow-1 d-flex flex-column justify-content-center">
                  <b-icon icon="inbox" shift-v="-2" font-scale="2"></b-icon>
                  <h5 class="mt-3">Aucune societe invitee</h5>
                  <p class="text-muted mb-0">Les invitations apparaitront ici une fois envoyees.</p>
                </div>

                <nav v-if="totalRows > 10" class="navbar navbar-expand-lg">
                  <li class="nav-item nav-link">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-2"
                    ></b-pagination>
                  </li>
                  <li class="nav-item nav-link d-flex align-items-center">
                    <span class="nowrap">Elements par page :</span>
                    <select v-model="perPage" class="form-control">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                    </select>
                  </li>
                  <li class="na-item nav-link">
                    <span>{{ totalRows }} / {{ invites.length }}</span>
                  </li>
                </nav>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
const Business = require('ppe-business')
import common from '../common/pages.js'

const INVITE_FILTERS_DEFAULTS = () => ({
  status: 'all',
  email: '',
  companyName: '',
  operationCode: '',
  operationName: '',
  operationEntity: '',
  createdStart: '',
  createdEnd: '',
  modifiedStart: '',
  modifiedEnd: '',
  inviteCount: '',
})

export default {
  name: 'EUUsers',
  mounted() {
    if (this.isManager()) {
      this.refreshData()
    }
  },
  data() {
    return {
      invites: [],
      isLoading: false,
      currentPage: 1,
      perPage: 20,
      columns: [
        { key: 'rank', label: '#' },
        { key: 'inviteStatus', label: 'Etat' },
        { key: 'email', label: 'Email' },
        { key: 'companyName', label: 'Societe' },
        { key: 'operationCode', label: 'Code' },
        { key: 'operationName', label: 'Operation' },
        { key: 'operationEntity', label: 'Entite' },
        { key: '_created', label: 'Envoye', tdClass: 'text-nowrap' },
        { key: '_modified', label: 'Relance', tdClass: 'text-nowrap' },
        { key: 'inviteCount', label: 'Envois' },
        { key: 'action', label: 'Action' },
      ],
      inviteColumnFilters: INVITE_FILTERS_DEFAULTS(),
    }
  },
  computed: {
    preparedInvites() {
      return this.invites.map(invite => {
        const operation = invite.operation || {}
        const company = operation.company || {}
        const operationId = operation.id || operation._id || invite.operation
        return {
          ...invite,
          operationCode: operation.code || '',
          operationName: operation.operationname || '',
          operationEntity: company.name || '',
          operationId,
        }
      })
    },
    filteredInvites() {
      const filters = this.inviteColumnFilters
      return this.preparedInvites.filter(invite => {
        const matchesStatus = filters.status === 'all' || invite.inviteStatus === filters.status
        const matchesEmail = this.matchesText(invite.email, filters.email)
        const matchesCompany = this.matchesText(invite.companyName, filters.companyName)
        const matchesOperationCode = this.matchesText(invite.operationCode, filters.operationCode)
        const matchesOperationName = this.matchesText(invite.operationName, filters.operationName)
        const matchesOperationEntity = this.matchesText(invite.operationEntity, filters.operationEntity)
        const matchesCreated = this.matchesDate(invite._created, filters.createdStart, filters.createdEnd)
        const matchesModified = this.matchesDate(invite._modified, filters.modifiedStart, filters.modifiedEnd)
        const matchesCount = this.matchesText(invite.inviteCount, filters.inviteCount)
        return (
          matchesStatus &&
          matchesEmail &&
          matchesCompany &&
          matchesOperationCode &&
          matchesOperationName &&
          matchesOperationEntity &&
          matchesCreated &&
          matchesModified &&
          matchesCount
        )
      })
    },
    inviteStatusOptions() {
      const options = [{ value: 'all', text: 'Tous' }]
      const statuses = Array.from(new Set(this.invites.map(invite => invite.inviteStatus).filter(Boolean)))
      statuses.forEach(status => options.push({ value: status, text: this.getInviteStatusLabel(status) }))
      return options
    },
    totalRows() {
      return this.filteredInvites.length
    },
    invitesSummary() {
      if (!this.invites.length) {
        return 'Aucune invitation disponible'
      }
      return `${this.totalRows} / ${this.invites.length} invitation(s) visibles`
    },
  },
  watch: {
    'inviteColumnFilters.createdStart'(value) {
      if (!value) {
        this.inviteColumnFilters.createdEnd = ''
      }
    },
    'inviteColumnFilters.modifiedStart'(value) {
      if (!value) {
        this.inviteColumnFilters.modifiedEnd = ''
      }
    },
  },
  methods: {
    ...common.methods,
    refreshData() {
      this.isLoading = true
      this.$http
        .get('/eu/operation_invites')
        .then(response => {
          this.invites = response.data.invites || []
        })
        .catch(err => {
          let error = JSON.parse(JSON.stringify(err))
          swal('Erreur', JSON.stringify(err.response ? err.response.data : error.message), 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    toDate(apiDate) {
      return Business.toDate(apiDate)
    },
    getInviteStatusLabel(status) {
      switch (status) {
        case 'sent':
          return 'Envoye'
        case 'resent':
          return 'Relance'
        case 'draft':
          return 'Brouillon'
        default:
          return status || ''
      }
    },
    isManager() {
      return this.$usermanager.isAdminManagerOrPartner()
    },
    matchesText(value, filterValue) {
      if (!filterValue) {
        return true
      }
      return (value || '').toString().toLowerCase().includes(filterValue.toLowerCase())
    },
    matchesDate(value, start, end) {
      if (!start && !end) {
        return true
      }
      if (!value) {
        return false
      }
      const currentDate = new Date(value)
      if (Number.isNaN(currentDate.getTime())) {
        return false
      }
      if (start) {
        const startDate = new Date(start)
        startDate.setHours(0, 0, 0, 0)
        if (currentDate < startDate) {
          return false
        }
      }
      if (end) {
        const endDate = new Date(end)
        endDate.setHours(23, 59, 59, 999)
        if (currentDate > endDate) {
          return false
        }
      }
      return true
    },
    resetInviteFilters() {
      Object.assign(this.inviteColumnFilters, INVITE_FILTERS_DEFAULTS())
    },
  },
}
</script>

<style>
.users-page .invites-card {
  min-height: calc(100vh - 230px);
  display: flex;
  flex-direction: column;
}

.users-page .invites-card .card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.invites-table-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.invites-table-wrapper .table-responsive {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.invites-table-wrapper table {
  margin-bottom: 0;
}

.invites-table-wrapper table th,
.invites-table-wrapper table td {
  font-size: 0.85rem;
}

.empty-state {
  border-radius: 0.75rem;
  background: #f8f9fc;
}

.nowrap {
  white-space: nowrap;
}
</style>
